/* THIS FILE IS GENERATED. DO NOT EDIT */

import { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { mergeProps } from '@/utils/merge';
import StandaloneScrollPageControls from 'base/components/standalone/ScrollPageControls';

export const DynamicStandaloneScrollPageControls = StandaloneScrollPageControls;
export type DynamicStandaloneScrollPageControlsProps = PropsFromComponent<typeof StandaloneScrollPageControls>;

export const DynamicStandaloneScrollPageControlsWith = (extras: DynamicStandaloneExtras): typeof StandaloneScrollPageControls => {
    return function DynamicStandaloneScrollPageControls(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'ScrollPageControls');
        return <StandaloneScrollPageControls {...mergeProps({ options: { theme } }, props)} />;
    }
}